import { SiteIdOverrideConfig } from "stores/wizard/config";
import { timeValues24HoursFormat } from "src/components/shared/TimeDropdown/config/time/timeValues";

export const siteId17: SiteIdOverrideConfig = {
  package: {
    showAllSubLOB: false,
  },
  car: {
    date: {
      queryParam: {
        start: "",
        end: "",
      },
    },
    form: {
      action: "https://rent-a-car.expedia.co.th/{locale}-th/book#/vehicles",
    },
    timeValues: timeValues24HoursFormat,
    defaultShowingTime: "10:30",
    carType: "CARTRAWLER",
    clientID: 312105,
    residenceID: "TH",
  },
};
